import numeral from 'numeral';

export const parseToMoney = n => numeral(n).format('0,0.00') 